/**
 * Spanish Caption Mapping
 * Maps video URLs to their Spanish .vtt caption files
 */

// Base path for caption files in public folder
const CAPTIONS_BASE = '/captions';

// Video URL to caption file mapping
const CAPTION_MAP = {
  // Session Intro Videos
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/tmy8n15o_Entrepreneurship%20101_%20Start%20Now.mp4': 
    `${CAPTIONS_BASE}/session_1_intro_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/wmyap5km_DISC%20Birds%20Teamwork%20%281%29.mp4': 
    `${CAPTIONS_BASE}/session_2_intro_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/9g81wmii_Business%20Plan%20Basics.mp4': 
    `${CAPTIONS_BASE}/session_3_intro_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/7dwvtmlv_Branding%20%26%20Promotion%20Explained.mp4': 
    `${CAPTIONS_BASE}/session_4_intro_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/bzxr48n1_Money%20Matters%20Made%20Simple.mp4': 
    `${CAPTIONS_BASE}/session_5_intro_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/wew6tu5u_Opening%20Day%20Challenges%20%281%29.mp4': 
    `${CAPTIONS_BASE}/session_6_intro_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/lih71tv8_Sweet%20Tast%20of%20Success%20Business%20Pitch.mp4': 
    `${CAPTIONS_BASE}/session_7_intro_es.vtt`,
  
  // Bonus Videos
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/qaee8kdu_Customer%20Service%20Essentials.mp4': 
    `${CAPTIONS_BASE}/bonus_customer_service_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/zba5ddv1_Sell%20With%20Heart.mp4': 
    `${CAPTIONS_BASE}/bonus_sell_with_heart_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/gkbsmf59_Confidence%20Before%20You%20Pitch.mp4': 
    `${CAPTIONS_BASE}/bonus_confidence_pitch_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/3tfk793a_What%20to%20Do%20If%20Someone%20Says%20No.mp4': 
    `${CAPTIONS_BASE}/bonus_handling_rejection_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/40txb35v_What%20Is%20Entrepreneurship_.mp4': 
    `${CAPTIONS_BASE}/bonus_what_is_entrepreneurship_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/zi9d73j0_Counting%20Money%20the%20Right%20Way.mp4': 
    `${CAPTIONS_BASE}/bonus_counting_money_es.vtt`,
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/qp6kmt5e_Teamwork%20in%20Action%20%281%29.mp4': 
    `${CAPTIONS_BASE}/bonus_teamwork_es.vtt`,
  
  // Completion Video
  'https://customer-assets.emergentagent.com/job_learn-lemons/artifacts/viu81vg1_What%20Comes%20Next_.mp4': 
    `${CAPTIONS_BASE}/completion_what_next_es.vtt`,
};

/**
 * Get Spanish caption URL for a video
 * @param {string} videoUrl - The video URL
 * @returns {object} - { hasSpanishCaptions: boolean, captionsSrc: string|null }
 */
export function getSpanishCaptions(videoUrl) {
  const captionUrl = CAPTION_MAP[videoUrl];
  return {
    hasSpanishCaptions: !!captionUrl,
    captionsSrc: captionUrl || null
  };
}

export default CAPTION_MAP;
